module.exports = __webpack_public_path__ + "img/pc_vr.9fe6ebe6.png";